import type { MouseEvent } from 'react';
import { Button, Flex, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { NavArrowRight, UserPlus } from 'iconoir-react';
import { browseColors } from './browse-tokens';

interface ProgramCardActionsProps {
  onInvite: () => void;
  onOpenDetail: () => void;
}

/** Stops the click from bubbling to the card, then runs the action. */
const withStop = (fn: () => void) => (event: MouseEvent) => {
  event.stopPropagation();
  fn();
};

/** Footer action row of a program card: invite and open-detail arrow. */
const ProgramCardActions = ({ onInvite, onOpenDetail }: ProgramCardActionsProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      mt="14px"
      pt="10px"
      gap="6px"
      align="center"
      borderTop="1px solid"
      borderColor={browseColors.footerBorder}
    >
      <Button
        variant="plain"
        onClick={withStop(onInvite)}
        h="30px"
        px="11px"
        minW="auto"
        gap="6px"
        borderRadius="full"
        border="1px solid"
        borderColor={browseColors.actionBorder}
        bg={browseColors.actionBg}
        color={browseColors.actionText}
        fontSize="12px"
        fontWeight={600}
        _hover={{ bg: browseColors.actionHoverBg }}
      >
        <UserPlus width={14} height={14} />
        {t('programs.browse.actions.invite')}
      </Button>

      <IconButton
        aria-label={t('programs.browse.actions.openDetail')}
        variant="plain"
        onClick={withStop(onOpenDetail)}
        ml="auto"
        boxSize="30px"
        minW="30px"
        borderRadius="full"
        border="1px solid"
        borderColor={browseColors.actionBorder}
        color={browseColors.arrowIcon}
        _hover={{ borderColor: browseColors.arrowHoverBorder, color: browseColors.arrowHoverIcon }}
      >
        <NavArrowRight width={15} height={15} />
      </IconButton>
    </Flex>
  );
};

export default ProgramCardActions;
